export const INSTAGRAM_VALIDATION = {
    desktop_background_url: {
        required: 'Background desktop wajib diisi',
    },
    mobile_background_url: {
        required: 'Background mobile wajib diisi',
    },
    title: {
        required: 'Title wajib diisi',
    },
    total: {
        required: 'Total posting wajib diisi',
    },
}
